// GamesGrid.js
import React from "react";
import { Link } from "react-router-dom";
import "./GamesGrid.css"; // Import grid styles
import GameRecomEmail from "./GameRecomEmail"; // Import the GameRecomEmail component
import SEOHead from "../SEO/SEOHead";
import { trackNavClick } from "../../utils/analytics";

const games = [
  {
    title: "One Piece",
    route: "/games/another-one-piece",
    image: require("../../assets/images/GamePageCovers/gamehom-One-Piece.png"),
  },
  {
    title: "Naruto",
    route: "/games/naruto",
    image: require("../../assets/images/GamePageCovers/gamehom-Naruto.png"),
  },
  {
    title: "Bleach",
    route: "/games/bleach",
    image: require("../../assets/images/GamePageCovers/gamehom-Bleach.png"),
  },
  {
    title: "One Punch",
    route: "/games/one-punch",
    image: require("../../assets/images/GamePageCovers/gamehom-OnePunch.png"),
  },
  {
    title: "Dragon Ball",
    route: "/games/dragon-ball",
    image: require("../../assets/images/GamePageCovers/gamehom-dragonball.jpg"),
  },
];

const GamesGrid = () => {
  return (
    <div className="games-container">
      <SEOHead
        title="ChibiDash | Anime Character Guessing Games"
        description="Play anime character guessing games on ChibiDash! Test your knowledge of One Piece, Naruto, Bleach, One Punch Man, and Dragon Ball characters."
        path="/games"
        keywords="anime games, anime quiz, anime trivia, one piece quiz, naruto quiz, bleach quiz, dragon ball quiz, one punch man quiz, anime character guessing game, anime character quiz"
      />
      <h1 className="games-title">Anime Character Guessing Games - How Well Do You Know Anime?</h1>
      <div className="games-grid">
        {games.map((game, index) => (
          <div className="game-card" key={index}>
            <div className="game-card-image-wrapper">
              {game.image ? (
                <img
                  src={game.image}
                  alt={game.title}
                  className="game-card-image"
                />
              ) : (
                <div className="game-card-placeholder">No Image</div>
              )}
            </div>
            <div className="game-card-content">
              <h3 className="game-card-title">{game.title}</h3>
              <Link to={game.route} className="game-card-link" onClick={() => trackNavClick('Games', game.title)}>
                Play Now
              </Link>
            </div>
          </div>
        ))}
      </div>

      {/* Add the GameRecomEmail component beneath the games */}
      <GameRecomEmail />
    </div>
  );
};

export default GamesGrid;